export const ADD_SINGLE_PRODUCT = "ADD_SINGLE_PRODUCT";
export const ADD_SINGLE_PRODUCT_LOADING = "ADD_SINGLE_PRODUCT_LOADING";
export const ADD_SINGLE_PRODUCT_ERROR = "ADD_SINGLE_PRODUCT_ERROR";
